import { Component, OnInit, Optional } from '@angular/core';
import { MetaDefinition } from '@angular/platform-browser';
import { MetaDataService } from '@common/util-foundation';

@Component({
  selector: 'sky-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Sky Protect Device Insurance';
  description = 'Cover for your Sky equipment and devices you love.';
  imageUrl = `${window.location.protocol}//${
    window.location.host
  }${window.location.pathname.substring(
    0,
    window.location.pathname.lastIndexOf('/')
  )}/assets/images/sky-preview.png`;

  metaDefinitions: MetaDefinition[] = [
    // Open Graph / Facebook / Whatsapp
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: this.title },
    { property: 'og:description', content: this.description },
    { property: 'og:image', content: this.imageUrl },
    // Twitter
    { property: 'twitter:card', content: 'summary_large_image' },
    { property: 'twitter:title', content: this.title },
    { property: 'twitter:description', content: this.description },
    { property: 'twitter:image', content: this.imageUrl },
    // Twitter
  ];
  constructor(@Optional() private readonly metadataService: MetaDataService) {}

  ngOnInit(): void {
    if (this.metadataService) {
      this.metadataService.setTitle(this.title);
      this.metadataService.setDescription(this.description);
      this.metadataService.setMetaTags(this.metaDefinitions);
    }
  }
}
